var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonElasticKubernetesService32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Elastic-Container-Kubernetes_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Elastic-Container-Kubernetes_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Containers",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.403,16.1433741 L19.403,19.4551416 L22.273,16.1433741 L23.716,16.1433741 L20.465,20.1487363 L23.882,24.3702329 L22.459,24.3702329 L19.403,20.5652861 L19.403,24.3564789 L18.117,24.3564789 L18.117,16.1433741 L19.403,16.1433741 Z M32,24.2493941 L28,21.8925474 L28,15.8250672 C28,15.6354584 27.888,15.4625509 27.713,15.3810093 L22,12.736311 L22,8.28492611 L32,13.1823337 L32,24.2493941 Z M32.722,12.4386351 L21.722,7.05197797 C21.567,6.97534852 21.383,6.98419038 21.237,7.0735914 C21.09,7.16299242 21,7.32116346 21,7.49112364 L21,13.0477409 C21,13.2373497 21.111,13.4112396 21.287,13.4917988 L27,16.1364971 L27,22.1705748 C27,22.3434823 27.091,22.5026357 27.243,22.5910543 L32.243,25.5383407 C32.322,25.5854973 32.411,25.6090756 32.5,25.6090756 C32.585,25.6090756 32.67,25.5874622 32.746,25.5452177 C32.903,25.4577816 33,25.2946984 33,25.1178612 L33,12.8777808 C33,12.6921017 32.892,12.5211591 32.722,12.4386351 L32.722,12.4386351 Z M19.995,32.9517485 L9,27.3165369 L9,13.1685797 L18,8.32029355 L18,12.7618542 L13.254,15.3977106 C13.096,15.4851468 13,15.64823 13,15.8250672 L13,24.6669264 C13,24.8457284 13.099,25.0107765 13.258,25.0972302 L19.758,28.6123605 C19.909,28.693902 20.091,28.693902 20.24,28.6133429 L26.49,25.2416472 L30.036,27.5719684 L19.995,32.9517485 Z M26.794,24.2592184 C26.638,24.1570458 26.439,24.1491864 26.275,24.2366226 L20,27.6220722 L14,24.3771099 L14,16.1119364 L18.746,13.4750975 C18.903,13.3886437 19,13.2245781 19,13.0477409 L19,7.49112364 C19,7.31723374 18.907,7.15709785 18.755,7.06867926 C18.603,6.98026067 18.415,6.97731338 18.259,7.0598374 L8.259,12.4474769 C8.099,12.5339307 8,12.6989787 8,12.8777808 L8,27.6142128 C8,27.797927 8.103,27.9649399 8.268,28.0504112 L19.768,33.944984 C19.84,33.9813339 19.921,34 20,34 C20.082,34 20.165,33.9803514 20.239,33.9400718 L31.239,28.045499 C31.392,27.962975 31.491,27.8087337 31.499,27.6368087 C31.507,27.4648836 31.424,27.3018004 31.278,27.2065048 L26.794,24.2592184 Z",
    id: "Amazon-Elastic-Container-Kubernetes_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonElasticKubernetesService32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Elastic-Kubernetes-Service_32.100ea70e4eb34b90a65e36e0a29d7573.svg";
export { ForwardRef as ReactComponent };